import logo from './logo.svg';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import Map from "./components/Map";
import { GeoJsonProvider } from "./state/GeojsonContext";
import { SnackbarProvider } from "./state/SnackbarContext";
import theme from './theme';
import { ThemeProvider } from '@mui/material/styles';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GeoJsonProvider>
        <SnackbarProvider>
          <Router basename='/mapa/'>
            <Routes>
              <Route path="/" element={<Map />} />
            </Routes>
          </Router >
        </SnackbarProvider>
      </GeoJsonProvider>
    </ThemeProvider>
  );
}

export default App;
